import * as React from 'react';

/** Enables click-and-drag horizontal scrolling on a container. */
export function useDragScroll(): React.RefObject<HTMLDivElement | null> {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    const onDragStart = (e: Event) => {
      e.preventDefault();
    };

    const onMouseDown = (e: MouseEvent) => {
      isDown = true;
      el.style.cursor = 'grabbing';
      el.style.userSelect = 'none';
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    };

    const stopDrag = () => {
      isDown = false;
      el.style.cursor = '';
      el.style.userSelect = '';
    };

    const onMouseMove = (e: MouseEvent) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5;
      el.scrollLeft = scrollLeft - walk;
    };

    el.addEventListener('dragstart', onDragStart);
    el.addEventListener('mousedown', onMouseDown);
    el.addEventListener('mouseleave', stopDrag);
    el.addEventListener('mouseup', stopDrag);
    el.addEventListener('mousemove', onMouseMove);

    return () => {
      el.removeEventListener('dragstart', onDragStart);
      el.removeEventListener('mousedown', onMouseDown);
      el.removeEventListener('mouseleave', stopDrag);
      el.removeEventListener('mouseup', stopDrag);
      el.removeEventListener('mousemove', onMouseMove);
    };
  }, []);

  return ref;
}
